// App
import React from 'react';

// Misc / utils
import * as S from './ToggleButton.styles';

export interface ToggleButtonProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-pressed' | 'aria-label'
> {
  ariaPressed?: boolean | 'true' | 'false' | 'mixed';
  ariaLabel?: string;
  icon?: string;
  iconWidth?: string;
  iconHeight?: string;
  iconAriaAltText?: string;
  isPressed?: boolean;
  toggleGroup?: boolean;
  children?: React.ReactNode;
}

const ToggleButton = React.forwardRef<HTMLButtonElement, ToggleButtonProps>(
  (
    {
      ariaPressed,
      ariaLabel,
      icon,
      iconWidth = '12px',
      iconHeight = '12px',
      iconAriaAltText = '',
      isPressed,
      onClick,
      children,
      toggleGroup,
      ...rest
    },
    ref,
  ) => {
    return (
      <S.ToggleButton
        onClick={onClick}
        ref={ref}
        isPressed={isPressed}
        toggleGroup={toggleGroup}
        aria-pressed={ariaPressed}
        aria-label={ariaLabel}
        {...rest}
      >
        {icon && <S.Icon src={icon} width={iconWidth} height={iconHeight} alt={iconAriaAltText} loading="lazy" />}
        <S.TextWrapper>{children}</S.TextWrapper>
      </S.ToggleButton>
    );
  },
);

ToggleButton.displayName = 'ToggleButton';
export default ToggleButton;
